
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, NgZone } from '@angular/core';
import { ProxyCmp, initOutputs } from '../lib';
import type { JSX, Components } from '@vime/core/dist/types';

import { 
  VmDblClickFullscreen 
} from '@vime/core';

import { define } from '../lib';
  

const DblClickFullscreenInputs: string[] = [
  'useOnMobile',
  'isFullscreenActive',
  'isVideoView',
  'playbackReady',
  'isMobile',
];

const DblClickFullscreenMethods: string[] = [
  
];

const DblClickFullscreenOutputs: string[] = [
  
];

export type Emitter<T extends ((...args: any[]) => any) | undefined> = EventEmitter<Parameters<Exclude<T, undefined>>[0]>;

export declare interface DblClickFullscreen extends Components.VmDblClickFullscreen {}

@ProxyCmp({
  inputs: DblClickFullscreenInputs,
  methods: DblClickFullscreenMethods,
})
@Component({
  selector: 'vm-dbl-click-fullscreen',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: DblClickFullscreenInputs,
  outputs: DblClickFullscreenOutputs,
})
export class DblClickFullscreen {
  protected el: HTMLElement;

  

  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    define('vm-dbl-click-fullscreen', VmDblClickFullscreen);
    c.detach();
    this.el = r.nativeElement;
    initOutputs(this, [])
  }
}
  